interface MetaInfoProps {
  refNo: string;
  date: string;
  name?: string;
  address?: string;
}

const MetaInfo = ({ refNo, date, name, address }: MetaInfoProps) => (
  <div className="mb-4 px-8 text-[11px]">
    <div className="flex flex-row justify-between text-[10px]" style={{fontFamily: "Times New Roman"}}>
    <p className="text-gray-400">Ref: {refNo}</p>
    <p className="text-gray-400">Date: {date}</p>
    </div>
    {name && (
    <p><b>Name:</b> {name}</p>
    )}
    {address && (
    <p><b>Address:</b> {address}</p>
    )}
  </div>
);

export default MetaInfo;
